module.exports = __webpack_public_path__ + "assets/img/reduce.68afae14.svg";